import React from 'react'
import { connect } from 'react-redux'
import Button from '../../../../../components/Button'

import SvgSelectAll from '../../../../../components/SVG/SelectAll'
import SvgClose from '../../../../../components/SVG/Close'

import { getTracks } from '../../../../../store/Search/extraSelectors'
import { toggleSelectedTrack } from '../../../../../store/Tracks/actions'

const VideoSelecetAll = ({
    tracks,
    hideEnded,
    selected,

    toggleSelectedTrack
}) => {

    const toggleSelectedAll = () => {
        const ids = tracks.map(el => el.id)

        toggleSelectedTrack({ ids, simple: true })

    }
    const toggleUnselectedAll = () => {


        toggleSelectedTrack({ ids: [], simple: true })


    }

    return (
        <>
        <div style={{width: 6}}/>
            <Button
                type="string"  
                disabled={!selected.length}
                onClick={toggleUnselectedAll}

            >
                <SvgClose size="xs" title="Очистить выбор" />
            </Button>

            <Button
                type="string"
                width={80}
                onClick={toggleSelectedAll}

            >
                <SvgSelectAll size="xs" title="Выделить все отображённые" />{`(${selected.length}/${tracks.length || 0})`}
            </Button>
        </>
    )
}

const mapStateToProps = (state, props) => {    
    let tracks = getTracks(state, props)

    if (state.tracks.hideEnded) {
        tracks = tracks.filter(track => !track.clipEnded)
    }

    return {

        tracks,        
        selected: state.tracks.selected
    }

}

const mapDispatchToProps = {
    toggleSelectedTrack
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoSelecetAll)